import { Helmet } from 'react-helmet-async';
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Button } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
// sections
import { LoginForm } from '../sections/auth/login';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: "#111111",
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');

  

  return (
    <>
      <Helmet>
        <title> Login | Falcon </title>
      </Helmet>

      <StyledRoot>

      

        {mdUp && (
          <StyledSection>
            <div  style={{ flexDirection: "row", display: "flex", paddingLeft: 40 }}>
          <Link href="/home"><img src='/assets/logo.svg' alt='azteq logo' height={30}/></Link>
          
          <img src='/assets/azteq_logo_authorized_distributor.png' alt='Apple  Authorized Distributor logo' height={50} style={{ marginLeft: 20}}/>
          </div>

            <Typography variant="h3" style={{ paddingLeft: 40, color:"white" }}>
              Hi, Welcome Back
            </Typography>
            <img src="/assets/illustrations/illustration_login.png" alt="login" />
          </StyledSection>
        )}

        <Container maxWidth="sm" >
          <StyledContent>
            <Typography variant="h4" gutterBottom sx={{ mb: 5 }}>
              Sign in to Falcon Admin Panel
            </Typography>

            <LoginForm />
          </StyledContent>
        </Container>
      </StyledRoot>
    </>
  );
}
